import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Button } from 'components/controls';
import styles from './SiteNavBar.scss';

export default function SiteNavbarLink(props) {
  const { Icon, label, variant, path, className, httpLink } = props;

  return (
    <Button
      Icon={Icon}
      label={label}
      variant={variant}
      href={path}
      httpLink={httpLink}
      className={classnames(styles.navBarLink, className)}
    />
  );
}

SiteNavbarLink.propTypes = {
  variant: PropTypes.string,
  label: PropTypes.string,
  path: PropTypes.string,
  className: PropTypes.string,
  httpLink: PropTypes.boolean,
};

SiteNavbarLink.defaultProps = {
  variant: 'common',
  label: '',
  path: '',
  className: '',
  httpLink: null,
};



// WEBPACK FOOTER //
// ./src/components/SiteNavBar/SiteNavBarLink.jsx